// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2_Mex","buttons":"SendReceipts_buttons__oqNDX","email":"SendReceipts_email__3d_GM","bookApptTitle":"SendReceipts_bookApptTitle__2HkO_"};